import { render, staticRenderFns } from "./MaterialLabelPrintTemplateSelect.vue?vue&type=template&id=6e3677d4&scoped=true&"
import script from "./MaterialLabelPrintTemplateSelect.vue?vue&type=script&lang=js&"
export * from "./MaterialLabelPrintTemplateSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3677d4",
  null
  
)

export default component.exports